// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyCyu98RAOw0h6YDLVu1AChu1P1v81OwZp8",
    authDomain: "rifaah-order-system-21cb4.firebaseapp.com",
    projectId: "rifaah-order-system-21cb4",
    storageBucket: "rifaah-order-system-21cb4.firebasestorage.app",
    messagingSenderId: "1080116260724",
    appId: "1:1080116260724:web:7884991f7d70983a530621",
    measurementId: "G-BBRJX645HZ"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
